export { default } from './ProductCardParams';
